import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
    getDoneWorksAllLogisticWorks: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS].GET_DONE_WORKS_ALL_LOGISTIC_WORKS
  },
}